import type { ApiResponse } from "#/types/api";
import api from "./client";

export interface UploadResponse {
  url: string;
}

export const uploadApi = {
  /** Uploads an image (PNG/JPEG/WebP, max 5 MB) and returns its public URL. */
  upload: async (file: File): Promise<string> => {
    const response = await api.uploadFile<ApiResponse<UploadResponse>>("/upload/image", file);
    return response.data.url;
  },
};
